function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .action-opps-eventbrite_svg__action-opps-eventbrite_svg__st0{fill:#F4462A}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    action-opps-eventbrite\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "action-opps-eventbrite_svg__action-opps-eventbrite_svg__mnsOAE_tif"
}, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-eventbrite_svg__action-opps-eventbrite_svg__st0",
  d: "M25.6,47.2h-1.3c-0.1,0-0.2,0-0.3,0C23,47.1,22,47,20.9,46.8C8.9,44.6,0.9,33,3.2,20.9S17,0.9,29.1,3.2 C38.5,4.9,45.7,12.5,47,22c0.1,0.7,0.1,1.5,0.2,2.3v0.1h-0.1l-29.8,6.9l-2.2,0.5l0.1,0.2c3.9,5.4,11.4,6.6,16.8,2.7 c1.1-0.8,2-1.7,2.7-2.8c0.1-0.2,0.3-0.3,0.5-0.2l8,1.8l2,0.5c-0.2,0.4-0.4,0.8-0.6,1.1C41.4,41.7,35.2,46.1,28,47 C27.2,47.1,26.4,47.1,25.6,47.2z M13.1,23.1l21.7-5c-3-4.3-8.5-6.1-13.5-4.6C17,14.9,13.9,18.6,13.1,23.1z"
}))));

function SvgActionOppsEventbrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgActionOppsEventbrite;